import { z } from 'zod';
import { RedirectMethods } from '../../constants/redirectMethods';

export const DepositResponseSchema = z.object({
  error: z.enum(['yes', 'no', '']),
  error_code: z.string(),
  response_query: z.string(),
  operation_id: z.number(),
  api_redirect_url: z.string().optional(),
  response: z.union([z.string(), z.record(z.unknown())]),
  redirect_method: z.nativeEnum(RedirectMethods),
  redirect_method_new: z.nativeEnum(RedirectMethods).optional()
});

export const WithdrawResponseSchema = z.object({
  error: z.enum(['yes', 'no', '']),
  error_code: z.string(),
  operation_id: z.number(),
  response: z.union([z.string(), z.record(z.unknown())]),
  api_redirect_url: z.string().optional(),
  redirect_method: z.nativeEnum(RedirectMethods).optional(),
  redirect_method_new: z.nativeEnum(RedirectMethods).optional(),
  address: z.string().optional(),
  city: z.string().optional(),
  secretCode: z.string().optional(),
  order: z.number().optional()
});
